import * as CommonUtils from "./common.utils";

export function setItem(key: string, value: any) {
  try {
    const ref: Record<"value", any> = { value };
    localStorage.setItem(key, JSON.stringify(ref));
    return value;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export function removeItem(key: string) {
  localStorage.removeItem(key);
}

export function getItem<T>(key: string): T | undefined {
  const value: any = localStorage.getItem(key);
  if (value !== null && value !== undefined && CommonUtils.isJsonString(value)) {
    const ref = JSON.parse(value);
    return ref.value;
  }
  return undefined;
}

export function clear() {
  localStorage.clear();
}
